import React, { useEffect, useState } from 'react';

import T, { Translate } from '../../i18n/i18n';
import { Container, LayerSelect, LayerInput, Button, RemoveGroup, RemoveRow, RemoveTitle, RemoveDesc } from './LayerSelector.styles';

export default ({value, selected, onChange}) => {

    const [isAdding, setIsAdding] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [isRemoving, setIsRemoving] = useState(false);
    const [newLayer, setNewLayer] = useState('');
    const [editLayer, setEditLayer] = useState('');
    const [layers, setLayers] = useState([]);
    const [selectedLayer, setSelectedLayer] = useState('');

    useEffect(() => {
        setLayers(value);
    }, [value]);

    useEffect(() => {
        setSelectedLayer(selected);
    }, [selected]);

    const handleSelect = (value) => {
        setSelectedLayer(value);
        onChange(layers, value);
    }

    const handleEnterAddMode = () => {
        setIsAdding(true);
    }

    const handleEnterEditMode = () => {
        for(let layer of layers) {
            if (layer.id === selectedLayer) {
                setEditLayer(layer.name);
            }
        }
        setIsEditing(true);
    }

    const handleEnterDeleteMode = () => {
        setIsEditing(false);
        setIsRemoving(true);
    }

    const handleSaveAdd = () => {
        let id = String((new Date()).getTime());
        let newLayers = [...layers, {id, name:newLayer}];
        setLayers(newLayers);
        setSelectedLayer(String(id));

        onChange(newLayers, String(id));
        setNewLayer('');
        setIsAdding(false);
    }

    const handleCancel = () => {
        setIsAdding(false);
        setIsEditing(false);
        setIsRemoving(false);
    }    

    const handleSaveEdit = () => {
        let newLayers = [...layers].map(i => ({
            id: String(i.id),
            name: (i.id === selectedLayer) ? editLayer : i.name
        }));

        setLayers(newLayers);
        onChange(newLayers, selectedLayer);
        setIsEditing(false);
    }

    const handleDelete = () => {
        let newLayers = [...layers].filter(i => i.id !== selectedLayer);
        setLayers(newLayers);
        setSelectedLayer('');
        onChange(newLayers, '');
        setIsRemoving(false);
    }

    const handleKeyPress = (event, callback) => {
        if (event.which === 13) {
            callback();
        }
    }

    return <Container>
        {!isAdding && !isEditing && !isRemoving && <>
            <LayerSelect value={selectedLayer} onChange={(e) => handleSelect(e.target.value)}>
                <option value="">{Translate('gridtools.baselayer')}</option>
                {(layers && layers.length) ? layers.map(layer => <option key={layer.id} value={layer.id}>{layer.name}</option>) : null}
            </LayerSelect>
            <Button icon={"\\F0E4D"} width={"30px"} color={"#0c0"} onClick={handleEnterAddMode} />
            {Boolean(selectedLayer) && <Button icon={"\\F09FE"} width={"30px"} color={"#fc0"} onClick={handleEnterEditMode} />}
        </>}
        {isAdding && !isEditing && !isRemoving && <>
            <LayerInput onKeyPress={(e) => handleKeyPress(e, handleSaveAdd)} value={newLayer} onChange={(e)=>{setNewLayer(e.target.value)}}/>
            <Button icon={"\\F012C"} width={"30px"} color={"#0c0"} onClick={handleSaveAdd} />
            <Button icon={"\\F0156"} width={"30px"} color={"#f33"} onClick={handleCancel} />
        </>}
        {!isAdding && isEditing && !isRemoving && <>
            <LayerInput onKeyPress={(e) => handleKeyPress(e, handleSaveEdit)} value={editLayer} onChange={(e)=>{setEditLayer(e.target.value)}}/>
            <Button icon={"\\F012C"} width={"30px"} color={"#0c0"} onClick={handleSaveEdit} />
            <Button icon={"\\F0E4E"} width={"30px"} color={"#f83"} onClick={handleEnterDeleteMode} />
            <Button icon={"\\F0156"} width={"30px"} color={"#f33"} onClick={handleCancel} />
        </>}
        {!isAdding && !isEditing && isRemoving && <RemoveGroup>
            <RemoveRow>
                <RemoveDesc>
                    <T value={"gridtools.confirmRemoveLayerDesc"}/>
                </RemoveDesc>
            </RemoveRow>
            <RemoveRow>
                <RemoveTitle>
                    <T value={"gridtools.confirmRemoveLayer"}/>
                </RemoveTitle>
                <Button width={"60px"} color={"#0c0"} onClick={handleDelete}><T value="yes"/></Button>
                <Button width={"60px"} color={"#f33"} onClick={handleCancel}><T value="no"/></Button>
            </RemoveRow>
        </RemoveGroup>}
    </Container>
}